var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1406 11.4768L14 13.2894L10.8667 11.4817L10.2617 11.831V12.5516L13.3851 14.3543V17.9818L14 18.336L14.6148 17.9818V14.3543L17.7554 12.5417V11.831L17.1406 11.4768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6172 6.99787L21.7578 8.81043L18.6172 10.6254L19.232 10.9796V11.6904L22.3727 9.87533V13.5029L23.6023 12.7922V8.45628L19.8469 6.28711L18.6172 6.99787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8547 6.14741L13.3805 4.689V6.2507H14.6101V4.689L17.1359 6.14741L18.3656 5.43665L13.9953 2.91333L9.625 5.43665L10.8547 6.14741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3672 15.2086V18.1254L21.0145 17.3433L20.3997 18.4082L21.7523 19.1903L19.2266 20.6462V22.0678L23.5969 19.5444V14.4978L22.3672 15.2086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.47222 12.8364L5.62812 13.5029V9.87533L8.78596 11.6977V10.9796L9.39342 10.6279L6.24543 8.81043L9.38605 6.99787L8.15636 6.28711L4.39844 8.45628V12.802C4.42303 12.8118 4.44762 12.8217 4.47222 12.8364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7554 21.4983L14.6148 23.3109V19.6858L14 20.0399L13.3851 19.6858V23.3109L10.2617 21.5082V22.9272L14 25.0866L17.7554 22.9174V21.4983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78596 20.6561L6.24297 19.1903L7.59562 18.4082L6.98078 17.3433L5.62812 18.1254V15.2086L4.39844 14.4978V19.5444L8.78596 22.0776V20.6561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1644 19.4447C12.0925 18.9089 12.1104 17.2024 11.2045 15.6332C10.2985 14.0641 8.8117 13.2264 7.8836 13.7622C6.9555 14.298 6.93756 16.0045 7.84353 17.5737C8.7495 19.1429 10.2363 19.9806 11.1644 19.4447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1771 17.5709C21.0831 16.0017 21.0652 14.2952 20.1371 13.7594C19.209 13.2235 17.7222 14.0612 16.8162 15.6304C15.9102 17.1996 15.9282 18.9061 16.8563 19.4419C17.7844 19.9777 19.2712 19.14 20.1771 17.5709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 10.752C15.8115 10.752 17.2804 9.88322 17.2804 8.81154C17.2804 7.73986 15.8115 6.87109 13.9996 6.87109C12.1876 6.87109 10.7188 7.73986 10.7188 8.81154C10.7188 9.88322 12.1876 10.752 13.9996 10.752Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDma);
export default __webpack_public_path__ + "static/media/dma.30ade0bb5241c555810c84fe03c61c6c.svg";
export { ForwardRef as ReactComponent };